export const SET_VOLUME = 'SET_VOLUME';
export const SET_AUDIO_TO_PLAY = 'SET_AUDIO_TO_PLAY';

/**
 * The thinking here is, I need to _know_ when to play a new
 * audio track. Before, when we were creating and destroying
 * <audio> tags with each view, we didn't have to worry
 * about being explicit here. But now, we need some mechanism
 * to trigger a `componentDidUpdate` on our `<AllAudio />`
 * component, _and_ make it so we know that update corresponds
 * with playing some audio.
 * 
 * I'm going to just keep a simple counter, that every time
 * we want to play something, we'll increment that counter.
 * 
 * A more semantic way would have a Redux Thunk, where we
 * dispatch some "PLAY" action, then when it actually plays
 * we dispatch a PLAYING event, similar to how we normally
 * handle AJAX / async requests. However, this works in a
 * pinch, so incremented counters it is.
 */
export const INCREMENT_AUDIO_COUNT = 'INCREMENT_AUDIO_COUNT';

/**
 * Similar setup to the above, use an increment when we want to
 * stop audio. Again, should probably have a STOPPING and
 * STOPPED flag, but oh well. 
 */
export const INCREMENT_STOP_AUDIO_COUNT = 'STOP_AUDIO';

export const SET_MENU_STATE = 'SET_MENU_STATE';
export const SET_OVERLAY_STATE = 'SET_OVERLAY_STATE';
export const SET_SECTION_AS_ANIMATED = 'SET_SECTION_AS_ANIMATED';
export const SET_USER_INTERACTED = 'SET_USER_INTERACTED';

export const TRIGGER_GTM_PUSH = 'TRIGGER_GTM_PUSH';
export const SET_NAV_METHOD_FOR_GTM = 'SET_NAV_METHOD_FOR_GTM'
